const REBUY_API_KEY = '73cf735a05bfe165dec6cf8079c4464d2ff5bde3';

// Use XMLHttpRequest, NOT fetch. A third-party pixel app (NestAds, na_pixel.js)
// monkey-patches window.fetch and its wrapper throws synchronously
// (`TypeError: i.includes is not a function`) on every call, which breaks all Rebuy
// requests intermittently. XHR is not patched by NestAds, so it reaches the API reliably.
const xhrGetJson = (url) =>
    new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                try {
                    resolve(JSON.parse(xhr.responseText));
                } catch (error) {
                    reject(error);
                }
            } else {
                reject(new Error(`Rebuy request failed: ${xhr.status}`));
            }
        };
        xhr.onerror = () => reject(new Error('Rebuy request network error'));
        xhr.send();
    });

export const getRebuyData = async ({ ruleId = '304460', productId, limit } = {}) => {
    const url = new URL(`https://rebuyengine.com/api/v1/custom/id/${ruleId}`);
    const params = {
        key: REBUY_API_KEY,
        filter_oos: 'yes',
        context: 'default',
        metafields: 'yes',
        ...(limit ? { limit } : {}),
        ...(productId ? { shopify_product_ids: `${productId}` } : {}),
    };

    Object.keys(params).forEach((param) => {
        url.searchParams.append(param, params[param]);
    });

    return xhrGetJson(url.toString());
};

export const getRebuySettings = async (widgetId) => {
    try {
        // The settings endpoint responds with `Cache-Control: max-age=1800,
        // stale-while-revalidate=1800`, so the browser serves a ~30–60 min stale copy.
        // The discount state (type/amount) lives here, so a merchant toggling the discount
        // in Rebuy would not reach the storefront for up to an hour. Bucket a cache-buster to
        // 60s: the discount syncs within a minute, while repeat views inside the bucket still
        // hit the CDN (one uncached request per edge per minute, not per page view).
        const cacheBucket = Math.floor(Date.now() / 60000);
        return await xhrGetJson(
            `https://rebuyengine.com/api/v1/widgets/settings?id=${widgetId}&_=${cacheBucket}`
        );
    } catch (error) {
        console.error('Error fetching Rebuy settings:', error);
        return null;
    }
};
